( function ($) {
    $(document).on('ready', function () {
        manageSingleBoard();
    });

    function manageSingleBoard() {
        //Select2 multi-choice
        var select2Multiple = $('#building_address');
        if (select2Multiple.length) {
            const items = gsap.utils.toArray('.single_board');
            const filters = gsap.utils.toArray('.filter-select');

            select2Multiple.on('change', function () {
                var value = $(this).val() ? $(this).val() : '';
                // console.log(value)
                // Get filter value from option value
                loadFilterSelect(value)
            });

            function loadFilterSelect(value) {
                let selector = $('#' + value);
                if (selector.length !== 0) {
                    let tlSingleBoard = gsap.timeline({ease: "power3.inOut", duration: 0.1 });
                    tlSingleBoard.to(items, {y: "100%", autoAlpha: 0});
                    tlSingleBoard.fromTo(selector, {y: "100%", autoAlpha: 0}, {y: "0", autoAlpha: 1});
                }
            }

            select2Multiple.select2();
        }
    }
}(jQuery) );